(function () {
  'use strict';

  var config = window.StoreLocatorConfig || {};
  var AU_CENTER = { lat: -25.2744, lng: 133.7751 };
  var map, infoWindow, geocoder;
  var allStores = [];
  var activeMarkers = [];
  var activeIndex = -1;
  var userMarker = null;
  var userLatLng = null;
  var locationKnown = false; // true once we have a real user/searched location

  // ── Entry point called by Google Maps callback ────────────────────────────

  window.initStoreLocator = function () {
    loadStores().then(function (stores) {
      allStores = stores;
      initMap();
      setupControls();
      locateUser();
    }).catch(function (err) {
      showError('Could not load stockist data. Please try again later.');
      console.error('[Store Locator]', err);
    });
  };

  // ── Data loading ──────────────────────────────────────────────────────────

  function loadStores() {
    return fetch(config.dataUrl)
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json();
      });
  }

  // ── Map initialisation ────────────────────────────────────────────────────

  function initMap() {
    map = new google.maps.Map(document.getElementById('store-map'), {
      center: { lat: -25.2744, lng: 133.7751 },
      zoom: 4,
      gestureHandling: 'greedy',
      mapTypeControl: false,
      streetViewControl: false,
      fullscreenControl: true,
      zoomControlOptions: {
        position: google.maps.ControlPosition.RIGHT_CENTER
      },
      styles: [
        { featureType: 'poi', elementType: 'labels', stylers: [{ visibility: 'off' }] }
      ]
    });
    infoWindow = new google.maps.InfoWindow();
    geocoder = new google.maps.Geocoder();
  }

  // ── Rendering ─────────────────────────────────────────────────────────────

  function renderStores(stores) {
    clearMarkers();
    activeIndex = -1;

    var listEl = document.getElementById('store-list');
    var countEl = document.getElementById('store-count');

    countEl.textContent = stores.length === 1
      ? '1 stockist found'
      : stores.length + ' stockists found';

    if (stores.length === 0) {
      listEl.innerHTML = '<p class="store-locator__empty">No stockists match your search.</p>';
      fitToContent(null);
      return;
    }

    var fragment = document.createDocumentFragment();
    var bounds = new google.maps.LatLngBounds();
    var hasCoords = false;

    stores.forEach(function (store, i) {
      if (store.lat && store.lng) {
        hasCoords = true;
        var pos = { lat: store.lat, lng: store.lng };
        bounds.extend(pos);

        var marker = new google.maps.Marker({
          position: pos,
          map: map,
          title: store.name,
          icon: pinIcon()
        });

        marker.addListener('click', function () {
          openInfoWindow(marker, store);
          setActive(i);
        });

        activeMarkers.push(marker);
      } else {
        activeMarkers.push(null);
      }

      fragment.appendChild(buildCard(store, i));
    });

    listEl.innerHTML = '';
    listEl.appendChild(fragment);

    fitToContent(hasCoords ? bounds : null, stores.length);
  }

  function fitToContent(bounds, count) {
    if (userLatLng) {
      if (!bounds) bounds = new google.maps.LatLngBounds();
      bounds.extend(userLatLng);
    }
    if (!bounds || bounds.isEmpty()) return;

    if (count === 1 && !userLatLng) {
      map.setCenter(bounds.getCenter());
      map.setZoom(14);
    } else {
      map.fitBounds(bounds, { top: 50, right: 50, bottom: 50, left: 50 });
    }
  }

  function buildCard(store, index) {
    var card = document.createElement('div');
    card.className = 'store-locator__card';
    card.dataset.index = index;

    var line1 = [store.address1, store.address2].filter(Boolean).join(', ');
    var line2 = [store.city, store.state, store.zip].filter(Boolean).join(' ');
    var addrHtml = [line1, line2].filter(Boolean).map(escHtml).join('<br>');

    var distanceHtml = (typeof store._distance === 'number')
      ? '<div class="store-locator__card-distance">' + formatKm(store._distance) + ' away</div>'
      : '';

    var linksHtml = '';
    if (store.lat && store.lng) {
      linksHtml += '<a href="' + directionsUrl(store) + '" class="store-locator__card-directions" target="_blank" rel="noopener noreferrer">Directions</a>';
    }
    if (store.website) {
      linksHtml += '<a href="' + escAttr(store.website) + '" class="store-locator__card-link" target="_blank" rel="noopener noreferrer">Visit website ↗</a>';
    }

    card.innerHTML =
      '<div class="store-locator__card-body">' +
        '<h3 class="store-locator__card-name">' + escHtml(store.name) + '</h3>' +
        '<p class="store-locator__card-address">' + addrHtml + '</p>' +
        distanceHtml +
        (linksHtml ? '<div class="store-locator__card-links">' + linksHtml + '</div>' : '') +
      '</div>';

    card.addEventListener('click', function (e) {
      // Don't hijack clicks on the links inside the card.
      if (e.target.closest('a')) return;
      var marker = activeMarkers[index];
      if (marker) {
        map.panTo(marker.getPosition());
        if (map.getZoom() < 12) map.setZoom(13);
        openInfoWindow(marker, store);
      }
      setActive(index);
    });

    return card;
  }

  // ── Pins ────────────────────────────────────────────────────────────────

  function pinIcon() {
    return teardrop(config.accentColor || '#1a1a1a');
  }

  function userPinIcon() {
    return teardrop('#e23b3b');
  }

  function teardrop(color) {
    var svg =
      '<svg xmlns="http://www.w3.org/2000/svg" width="28" height="40" viewBox="0 0 28 40">' +
        '<path d="M14 1.5C7.1 1.5 1.5 7.1 1.5 14c0 9.1 12.5 24.5 12.5 24.5S26.5 23.1 26.5 14C26.5 7.1 20.9 1.5 14 1.5z" ' +
          'fill="' + color + '" stroke="#0B3C5B" stroke-width="1" stroke-linejoin="round"/>' +
        '<circle cx="14" cy="14" r="4.5" fill="#ffffff"/>' +
      '</svg>';
    return {
      url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg),
      scaledSize: new google.maps.Size(28, 40),
      anchor: new google.maps.Point(14, 39)
    };
  }

  function setUserMarker(latLng) {
    if (userMarker) userMarker.setMap(null);
    userMarker = new google.maps.Marker({
      position: latLng,
      map: map,
      title: 'Your location',
      icon: userPinIcon(),
      zIndex: 9999
    });
  }

  // ── Info window ───────────────────────────────────────────────────────────

  function openInfoWindow(marker, store) {
    var line1 = [store.address1, store.address2].filter(Boolean).join(', ');
    var line2 = [store.city, store.state, store.zip].filter(Boolean).join(' ');
    var addrHtml = [line1, line2].filter(Boolean).map(escHtml).join('<br>');

    var rows = '';
    if (store.phone) {
      rows += '<div class="sloc-iw__row"><span class="sloc-iw__label">Phone:</span> ' +
        '<a href="tel:' + escAttr(store.phone) + '">' + escHtml(store.phone) + '</a></div>';
    }
    if (store.email) {
      rows += '<div class="sloc-iw__row"><span class="sloc-iw__label">Email:</span> ' +
        '<a href="mailto:' + escAttr(store.email) + '">' + escHtml(store.email) + '</a></div>';
    }

    infoWindow.setContent(
      '<div class="sloc-iw">' +
        '<strong class="sloc-iw__name">' + escHtml(store.name) + '</strong>' +
        '<div class="sloc-iw__addr">' + addrHtml + '</div>' +
        (rows ? '<div class="sloc-iw__contact">' + rows + '</div>' : '') +
      '</div>'
    );
    infoWindow.open(map, marker);
  }

  // ── Active state ──────────────────────────────────────────────────────────

  function setActive(index) {
    var cards = document.querySelectorAll('.store-locator__card');
    cards.forEach(function (c) { c.classList.remove('is-active'); });

    var target = document.querySelector('.store-locator__card[data-index="' + index + '"]');
    if (target) {
      target.classList.add('is-active');
      target.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
    activeIndex = index;
  }

  // ── Search controls (location / radius / results) ──────────────────────────

  function setupControls() {
    var geoEl = document.getElementById('geo-input');
    var radiusEl = document.getElementById('radius-filter');
    var searchBtn = document.getElementById('geo-search');
    var locateBtn = document.getElementById('geo-locate');

    function runSearch() {
      var q = (geoEl.value || '').trim();
      if (!q) { locateUser(); return; }

      searchBtn.disabled = true;
      searchBtn.textContent = 'Searching…';

      geocoder.geocode(
        { address: q, componentRestrictions: { country: 'AU' } },
        function (results, status) {
          searchBtn.disabled = false;
          searchBtn.textContent = 'Search';

          if (status !== 'OK' || !results[0]) {
            showError('Couldn’t find that location. Try a postcode or suburb.');
            return;
          }
          var loc = results[0].geometry.location;
          setLocation({ lat: loc.lat(), lng: loc.lng() }, true);
        }
      );
    }

    searchBtn.addEventListener('click', runSearch);
    geoEl.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); runSearch(); }
    });
    radiusEl.addEventListener('change', applyResults);
    if (locateBtn) locateBtn.addEventListener('click', locateUser);
  }

  // Ask the browser for the visitor's location; fall back to the centre of
  // Australia (no radius filter) if they decline or it's unavailable.
  function locateUser() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        function (pos) {
          setLocation({ lat: pos.coords.latitude, lng: pos.coords.longitude }, true);
        },
        function () { setLocation(AU_CENTER, false); },
        { timeout: 8000, maximumAge: 600000 }
      );
    } else {
      setLocation(AU_CENTER, false);
    }
  }

  function setLocation(latLng, known) {
    userLatLng = latLng;
    locationKnown = known;
    setUserMarker(latLng);
    applyResults();
  }

  // With a real location: show distances, sort nearest-first, filter to radius.
  // Without one (geolocation declined): show all stores, no distance shown.
  function applyResults() {
    if (!locationKnown || !userLatLng) {
      allStores.forEach(function (s) { delete s._distance; });
      renderStores(allStores);
      return;
    }

    var radiusEl = document.getElementById('radius-filter');
    var radius = (radiusEl && radiusEl.value) ? parseFloat(radiusEl.value) : Infinity;

    var list = allStores
      .filter(function (s) { return s.lat && s.lng; })
      .map(function (s) {
        s._distance = haversine(userLatLng.lat, userLatLng.lng, s.lat, s.lng);
        return s;
      })
      .sort(function (a, b) { return a._distance - b._distance; });

    if (isFinite(radius)) {
      list = list.filter(function (s) { return s._distance <= radius; });
    }

    renderStores(list);
  }

  // ── Utilities ─────────────────────────────────────────────────────────────

  function directionsUrl(store) {
    var dest = store.lat + ',' + store.lng;
    var url = 'https://www.google.com/maps/dir/?api=1&destination=' + encodeURIComponent(dest);
    if (userLatLng) url += '&origin=' + encodeURIComponent(userLatLng.lat + ',' + userLatLng.lng);
    return url;
  }

  function haversine(lat1, lng1, lat2, lng2) {
    var R = 6371; // km
    var dLat = toRad(lat2 - lat1);
    var dLng = toRad(lng2 - lng1);
    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
      Math.sin(dLng / 2) * Math.sin(dLng / 2);
    return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  }

  function toRad(deg) { return deg * Math.PI / 180; }

  function formatKm(d) {
    return (Math.round(d * 10) / 10) + ' km';
  }

  function clearMarkers() {
    activeMarkers.forEach(function (m) { if (m) m.setMap(null); });
    activeMarkers = [];
  }

  function showError(msg) {
    var listEl = document.getElementById('store-list');
    if (listEl) listEl.innerHTML = '<p class="store-locator__error">' + escHtml(msg) + '</p>';
  }

  function escHtml(str) {
    if (str === null || str === undefined) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function escAttr(str) {
    return escHtml(str).replace(/'/g, '&#39;');
  }
})();
